/* global $ */

import './includes/adLoader';
import renderChart from './includes/gridChart';

$(document).keydown(function(e) {
  // ESCAPE key press - close modal
  if (e.keyCode === 27) {
    $('#graph__modal--close').trigger('click');
    e.preventDefault();
  }
});

var resizeId;

$(window).resize(function(){
     // compare the corresponding variables.
   if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
     clearTimeout(resizeId);
     resizeId = setTimeout(function() {
       if( $(window).width() > 1279 || $('#graph__modal').hasClass('open')) {
         $('.graph__modal--fixed').width($('#sections').width());
       }
     }, 500);
    } else {
      clearTimeout(resizeId);
      resizeId = setTimeout(doneResizing, 500);
    }

});

function doneResizing() {
  renderChart();

  if( $(window).width() > 1279 || $('#graph__modal').hasClass('open')) {
    $('.graph__modal--fixed').width($('#sections').width());
  }
}

renderChart();



/** WEBPACK FOOTER **
 ** ./main.js
 **/